/* ==========================================================================
   CART FEEDBACK

   Two things, both asked for on 29 Aug once the panel stopped opening on an add:

   1. "can we do an animation of something physically going in an arc from the
      add to cart button to the cart?" A copy of the product image flies to the
      cart icon and the icon takes the hit.

      That animation is now load-bearing, not decoration. With the panel no
      longer opening there is nothing else on a desktop screen that moves when
      an add succeeds, so this and the toast are the whole confirmation.

   2. "whilst you have items in your cart the cart icon should do its hover
      animation of rainbow and wiggle periodically to remind the buyer they have
      stuff." Same wiggle and same paint server as the hover, on a timer, only
      while the cart is not empty.

   WHERE IT HOOKS. PUB_SUB_EVENTS.cartUpdate, which product-form.js publishes on
   a successful add BEFORE it renders the cart sections. So the flight starts
   while the request has already come back true, and it cannot fire on a failure.

   WHAT IT NEVER DOES. It never touches the cart, the form or the panel. If any
   part of this throws, the add has already happened.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__stkCartFx) return;
  window.__stkCartFx = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function events() {
    return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  }

  function cartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  /* ---- the flight ---------------------------------------------------------- */

  /* THE BUTTON, NOT THE PRODUCT IMAGE. It flew from the image first, which is
     a picture of the thing going into the cart and reads nicely in principle,
     but on a scrolled page the image is often above the fold and the arc then
     starts somewhere nobody is looking. Thomas, 29 Aug: "theres no sign of my
     dot going from the add to cart to the cart icon in an arc", which is what
     he asked for in the first place: "an arc from the add to cart button to the
     cart".

     The sticky bar's clone counts: whichever button is actually on screen is
     the one the parcel should leave from. */
  function onScreen(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 8 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function source() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-stkb]'));
    var visible = buttons.filter(onScreen);
    return visible[visible.length - 1] || buttons[0] || null;
  }

  /* WHERE THE PARCEL IS AIMED, and this is why nothing appeared to happen.

     His header is not sticky. Scrolled down to the Add to cart button, which is
     the only place anybody clicks it, #cart-icon-bubble is ABOVE the viewport
     and its rectangle is negative. The parcel was therefore flying correctly,
     straight off the top of the screen, in about a tenth of a second. Thomas
     twice: "no sign of any arcing dot going from the add to cart button to the
     cart icon."

     When the icon is out of sight the parcel aims at where the toast is about to
     appear instead, top right under where the icon would be. cart-lab.css does
     the same thing for the same reason and floors the toast at 68px, so the two
     agree about where "the cart" is when the real one has scrolled away. */
  function target(icon, size) {
    var b = icon.getBoundingClientRect();
    var cx = b.left + b.width / 2;
    var cy = b.top + b.height / 2;
    var margin = 8;
    if (b.width && cy > margin && cy < window.innerHeight - margin) {
      return { x: cx, y: cy, onScreen: true };
    }
    return { x: window.innerWidth - 12 - size / 2, y: 68 + size / 2, onScreen: false };
  }

  /* Every number the parcel uses comes off the cart icon, which the header
     renders with the merchant's settings on it. Nothing about the animation is
     decided in here. */
  function opts(icon) {
    var num = function (name, fallback) {
      var v = parseInt(icon.getAttribute(name), 10);
      return isNaN(v) ? fallback : v;
    };
    return {
      on: !icon.hasAttribute('data-stkfx-fly') || icon.getAttribute('data-stkfx-fly') === '1',
      ms: num('data-stkfx-fly-ms', 460),
      size: num('data-stkfx-fly-size', 42),
      icon: icon.getAttribute('data-stkfx-fly-icon') || 'cart',
      fill: icon.getAttribute('data-stkfx-fly-fill') || 'rainbow',
      color: icon.getAttribute('data-stkfx-fly-color') || ''
    };
  }

  function fly(from, to) {
    var a = from.getBoundingClientRect();
    if (!a.width) return;

    var set = opts(to);
    if (!set.on) return;

    var size = set.size;
    var aim = target(to, size);
    /* A REAL CHILD, NOT A ::after.
       Dawn's base.css carries `div:empty { display: none }`, and a pseudo
       element does not stop an element being :empty. So this parcel was built
       correctly, positioned correctly, animated correctly, and never painted
       once: display none from the first frame. Thomas, three times, "no sign of
       any arcing dot" and finally "no theres literally no parcel at all".

       `div:empty` is specificity 0,1,1 against a class at 0,1,0, so it also won
       outright. Giving the parcel a child sidesteps both facts at once rather
       than out-specifying one of them. */
    var ghost = document.createElement('div');
    ghost.className = 'stkfx-fly';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    var glyph = ghost.appendChild(document.createElement('span'));
    glyph.className = 'stkfx-fly__ic stkfx-fly__ic--' + set.icon;
    if (set.fill === 'solid' && set.color) {
      ghost.style.backgroundImage = 'none';
      ghost.style.backgroundColor = set.color;
    }
    document.body.appendChild(ghost);

    var x0 = a.left + a.width / 2 - size / 2;
    var y0 = a.top + a.height / 2 - size / 2;
    var x1 = aim.x - size / 2;
    var y1 = aim.y - size / 2;

    /* A quadratic bezier with the control point lifted above the higher of the
       two ends, so the parcel always arcs UP and over rather than sagging
       through the page. Sampled into keyframes because motion-path with a
       computed path is far more code for the same curve. */
    var lift = Math.max(90, Math.abs(y1 - y0) * 0.55 + 60);
    var cx = (x0 + x1) / 2;
    var cy = Math.min(y0, y1) - lift;

    var frames = [];
    var steps = 26;
    for (var i = 0; i <= steps; i++) {
      var t = i / steps;
      var m = 1 - t;
      var x = m * m * x0 + 2 * m * t * cx + t * t * x1;
      var y = m * m * y0 + 2 * m * t * cy + t * t * y1;
      frames.push({
        transform:
          'translate(' + (x - x0) + 'px,' + (y - y0) + 'px) scale(' + (1 - 0.62 * t) + ') rotate(' + t * 26 + 'deg)',
        opacity: t < 0.06 ? t / 0.06 : t > 0.82 ? (1 - t) / 0.18 : 1
      });
    }

    ghost.style.left = x0 + 'px';
    ghost.style.top = y0 + 'px';

    /* SHORT, AND THE HIT COMES BEFORE THE END.

       Shopify re-renders the cart sections the moment the response lands, so
       the count in the icon changes at roughly zero. The flight used to take
       760ms and the icon was hit only when it finished, which put a full second
       between the number changing and anything acknowledging it. Thomas, 29
       Aug: "the number is changing way before the rainbow pulse of the icon
       about 1 second delay."

       Two changes: the flight is faster, and the icon is hit at 62% of it
       rather than at the end, so the pulse is already running as the parcel
       arrives instead of starting after it. The parcel is fading out over that
       last stretch anyway. */
    var ms = set.ms;
    var anim = ghost.animate(frames, {
      duration: ms,
      easing: 'cubic-bezier(0.35, 0, 0.4, 1)',
      fill: 'forwards'
    });

    /* HIT THE ICON WHEN THE COUNT ACTUALLY CHANGES, not on a guessed delay.
       Shopify re-renders the icon when the response lands, and how long that
       takes is the network's business, so any fixed offset is right on one
       connection and wrong on every other. Watching for the change means the
       pulse and the new number happen on the same frame. The timer is only a
       floor, for the case where the count does not change at all. */
    var hit = false;
    var strike = function () {
      if (hit) return;
      hit = true;
      if (watcher) watcher.disconnect();
      bump(to);
    };
    var watcher = null;
    if (window.MutationObserver) {
      watcher = new MutationObserver(strike);
      watcher.observe(to, { childList: true, subtree: true });
    }
    setTimeout(strike, Math.round(ms * 0.62));

    var done = function () {
      ghost.remove();
    };
    if (anim.finished && anim.finished.then) anim.finished.then(done, done);
    else setTimeout(done, ms + 60);
  }

  function bump(icon) {
    icon.classList.remove('stkfx-land');
    /* Reading offsetWidth forces the class removal to take before it is added
       again, otherwise two adds in a row only animate once. */
    void icon.offsetWidth;
    icon.classList.add('stkfx-land');
    setTimeout(function () {
      icon.classList.remove('stkfx-land');
    }, 700);
  }

  /* ---- the reminder -------------------------------------------------------- */

  var timer = null;

  function hasItems() {
    var icon = cartIcon();
    return !!(icon && icon.querySelector('.cart-count-bubble'));
  }

  function nudge() {
    var icon = cartIcon();
    if (!icon || !hasItems() || document.hidden || REDUCED.matches) return;
    /* Never while the panel is open or while they are already on it: the point
       is to remind somebody who has forgotten, not to fidget at somebody who is
       looking straight at it. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return;
    if (document.querySelector('.skc-toast.is-in')) return;

    icon.classList.add('stkfx-nudge');
    setTimeout(function () {
      icon.classList.remove('stkfx-nudge');
    }, 1400);
  }

  var firstRun = null;

  function schedule() {
    if (timer) clearInterval(timer);
    if (firstRun) clearTimeout(firstRun);

    var icon = cartIcon();
    var every = icon ? parseInt(icon.getAttribute('data-stkfx-every'), 10) : NaN;

    /* 0 is a real answer: the header setting uses it to turn the reminder off,
       so it must not fall through to a default the way a missing attribute
       does. */
    if (icon && icon.hasAttribute('data-stkfx-every') && every === 0) return;
    if (isNaN(every) || every < 2000) every = 7000;

    /* Somebody who lands with a cart already full should be told before the
       first full interval has gone by, so there is one early run. Thomas, 29
       Aug: "the cart icon when theres stuff in your cart isnt animating often
       enough." */
    firstRun = setTimeout(nudge, Math.min(4000, every));
    timer = setInterval(nudge, every);
  }

  /* ---- wiring -------------------------------------------------------------- */

  function start() {
    schedule();

    var E = events();
    if (typeof subscribe === 'function' && E) {
      subscribe(E.cartUpdate, function (payload) {
        var icon = cartIcon();
        if (!icon || REDUCED.matches) return;
        /* The header is re-rendered from the response a moment later, so the
           icon this flies to may be replaced under it. Harmless: the flight is
           a fixed-position element of its own and only reads the rectangle. */
        var from = source();
        if (from) fly(from, icon);
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
